import React from 'react';
import { useTranslation } from 'react-i18next';
import { MainArea, Page, TopArea, Heading, P } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { ReportableDataProvider } from '../context/ReportableDataProvider';
import { ReportableDashboard } from './ReportableDashboard';
import { usePreferencesState } from 'core/preferences/usePreferencesContext';
import { useUserDetails } from 'core/app/AppContext';

export const ReportableDashboardPage: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { timezone } = usePreferencesState();
  const { username } = useUserDetails();
  return (
    <ReportableDataProvider timezone={timezone}>
      <MainArea>
        <TopArea>
          <AppTopBar />
        </TopArea>
        <Page>
          <Heading>
            <span data-hj-suppress>{t('welcome.heading', { username, context: username ? 'name' : null })}</span>
          </Heading>
          <P>{t('welcome.subtitle')}</P>
          <ReportableDashboard />
        </Page>
      </MainArea>
    </ReportableDataProvider>
  );
};
